<template>
  <div id="layTop">
    <img class="img_1" src="@/assets/images/pulic_5.png" />
    <div class="top" v-if="!['/zhver'].includes($route.path)">
      <i @click="getTo" class="iconshouye4 iconfont"></i>
      <p @click="getTo">首页</p>
    </div>
    <div class="logo">
      <p>{{  (library_infor && library_infor.name_lang ? library_infor.name_lang.zh  : '')}}</p>
    </div>
    <div class="bottom">
      <Dropdown placement="bottom" @on-click="userClick">
        <img v-if="infoname.wx_img" :src="infoname.wx_img" />
        <p>
          {{
            infoname
              ? infoname.nickname
                ? infoname.nickname
                : infoname.username
                ? infoname.username
                : infoname.tel
                ? infoname.tel
                : ""
              : "" | U2M
          }}
        </p>
        <DropdownMenu slot="list">
          <DropdownItem :name="2">退出登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <img class="img_2" src="@/assets/images/pulic_5.png" />
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    getTo() {
      this.$router.push({
        path:'/zhver',
        query: {
          lib_type: sessionStorage.getItem("gcm"),
        },
      });
    },
    userClick() {
      let that = this;
      that.saveUserBehavior(0, "点击退出登录按钮", 0);
      let data = {
        login_id: JSON.parse(
          this.$crypto.get(localStorage.getItem("userInfos"))
        ).login_id,
      };

      that.$http.post("api/web/v1/member/signout", data).then((val) => {
        localStorage.clear();
        document.title = ''
        that.$router.push({
          path: "/login",
          query: {
            lib_type: sessionStorage.getItem("gcm"),
          },
        });
      });
    },
    saveUserBehavior(type, mark, id) {
      let that = this;

      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      };
      that.$store.dispatch("saveUserBehavior", info).then(() => {});
    },
  },
  computed: {
    infoname() {
      let vv = localStorage.getItem("userInfos")
        ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfos")))
        : null;
      return vv;
    },
    library_infor: {
      get: function () {
        let myDate = localStorage.getItem("theme_color") ?
            JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))) : ''
        return myDate;
      },
      set: function (newValue) {
        return newValue;
      },
    }

  },
  created() {}
};
</script>
<style lang="less" scoped>
#layTop {
  height: 80px;
  width: 100%;
  background: var(--themeColor);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .img_1 {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: auto;
  }

  .img_2 {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: auto;
  }

  .top {
    position: absolute;
    top: 0;
    left: 20px;
    height: 100%;
    min-width: 200px;
    color: #ffffff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    line-height: 36px;

    i {
      font-size: 20px;
      cursor: pointer;
    }

    p {
      cursor: pointer;
      padding-left: 5px;
    }
  }

  .logo {
    position: absolute;
    top:0px;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 24px;
    p{
      height: 100%;
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
    }
  }

  .bottom {
    position: absolute;
    top: 0;
    right: 35px;
    height: 100%;
    width: 250px;
    color: #ffffff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    i {
      font-size: 14px;
      cursor: pointer;
    }

    p {
      cursor: pointer;
    }

    img {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      margin-bottom: 5px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
#layTop {
  .ivu-dropdown-rel {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
